<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="title"
      :modal="true"
      :width="'500px'"
      @open="onOpenWindow"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="pop-container">
      <div class="pop-conts">
        <div class="pwindow">
          <ul class="filter_list">
            <li>
              <label>무게(kg)<span class="forg">*</span></label>
              <ul class="w70">
                <li>
                  <input
                      type="number"
                      v-model="weight"
                      @input="weight=EtnersCommonUtil.cutByteLength(weight, 20)"
                      placeholder="kg"
                  >
                </li>
              </ul>
            </li>
            <li>
              <label>이메일</label>
              <ul class="w70">
                <li>
                  <input
                      type="text"
                      v-model="sendMailAddr"
                      @input="sendMailAddr=EtnersCommonUtil.cutByteLength(sendMailAddr, 200)"
                      placeholder="이메일을 입력하세요."
                  >
                  안내 메일발송을 위해 이메일 주소를 입력해주세요
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="button_area w60 mgt30">
          <ul>
            <li class="w25">
              <button class="large_btn" @click="onClickCloseWindow">취소</button>
            </li>
            <li class="w25">
              <button class="large_btn orange ml5" @click="onClickSaveData">저장</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </kendo-window>
</template>

<script>
import EtnersCommonUtil from "@/common/etners.common.util";
import EtnersLogisticsUtil from '@/common/etners.logistics.util'

export default {
  name: "DeliRequiredInfoForDeli",
  props: {
    title: {
      type: String,
      required: false,
      default: function () {
        return "title"
      }
    },
    propsSendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
  },
  methods: {
    onOpenWindow () {
      const vm = this
      vm.weight = vm.propsSendInfo.weight
      vm.sendMailAddr = vm.propsSendInfo.sendMailAddr
    },
    onClickCloseWindow () {
      this.$refs.kendoWindowRef.kendoWidget().close()
    },
    onClickSaveData () {
      const vm = this
      let weight = vm.weight
      let sendMailAddr = vm.sendMailAddr

      //필수값 체크
      if (!!!weight || weight === '0') {
        kendo.alert('무게를 입력해주세요.')
        return
      } else if (/^[0]+$/.test(weight) || (!!weight && weight.indexOf('-')>-1)) {
        kendo.alert('무게를 숫자만 입력해주세요.')
        return
      } else {
        weight = (Math.round(weight*10)/10).toString()
      }
      if (EtnersCommonUtil.isNotEmpty(sendMailAddr) && !EtnersLogisticsUtil.isEmailDomainAllowed(sendMailAddr)) {
        kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(""))
        return
      }
      vm.$emit('getInfoForDeli', weight, sendMailAddr)
      vm.onClickCloseWindow()
    },
  },
  data () {
    return {
      EtnersCommonUtil: EtnersCommonUtil,
      weight: '0',
      sendMailAddr: null,
    }
  }
}
</script>

<style scoped>

</style>
